<template>
  <div class="content-page">
    <div class="tab-header">
      <el-button type="primary" size="medium" @click="addMarketingActivity"
        >新增活动</el-button
      >
    </div>
    <div class="tab-content">
      <el-table :data="activeList" style="width: 100%" :max-height="550">
        <el-table-column
          align="left"
          prop="activityName"
          label="活动名称"
        ></el-table-column>
        <el-table-column align="center" prop="startTime" label="有效时间" width="380">
          <template slot-scope="scope">
            {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="resourcesNum"
          label="资源数"
        ></el-table-column>
        <el-table-column align="center" prop="usedNum" label="已使用数"></el-table-column>
        <el-table-column align="center" prop="timeStatus" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.timeStatus == 1
                ? "未开始"
                : scope.row.timeStatus == 2
                ? "进行中"
                : scope.row.timeStatus == 3
                ? "已结束"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              v-show="isHavMatrixCode"
              type="primary"
              size="small"
              @click="batchPublishMatrixCode(scope.row)"
              >发布到矩阵号</el-button
            >
            <el-button type="primary" size="small" @click="lookDetail(scope.row)"
              >资源</el-button
            >
            <el-button type="primary" size="small" @click="updateActive(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="delActive(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="activeList.length > 0" style="padding-left: 15px">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="pageNo"
        background
        layout="total, prev, pager, next"
        :total="pageCount"
      ></el-pagination>
    </div>
    <div
      class="popup add-matrix-code"
      :class="{
        show: isShowAddMartixCodeGroupPopup,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>发布到矩阵号</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowAddMartixCodeGroupPopup = false"
          />
        </div>
        <div class="popup-container">
          <div class="form-item">
            <div class="form-title">分组名称</div>
            <div class="form-content">
              <el-select
                v-model="addMatrixCodeForm.groupId"
                size="small"
                placeholder="请选择分组"
                clearable
                @change="groupIdChange"
              >
                <el-option
                  v-for="item in matrixCodeList"
                  :key="item.groupId"
                  :label="item.groupName"
                  :value="item.groupId"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-item" v-show="addMatrixCodeForm.groupId">
            <div class="form-title">组员</div>
            <div class="form-content">
              <el-select
                size="small"
                v-model="addMatrixCodeForm.memberIds"
                multiple
                placeholder="请选择组员"
              >
                <el-option
                  v-for="item in groupMemberList"
                  :key="item.bdmItemId"
                  :label="item.authorizerNickName"
                  :value="item.bdmItemId"
                >
                </el-option>
              </el-select>
              <p class="text-red">(不单选组员，视为选择所有组员)</p>
            </div>
          </div>
          <div class="form-item">
            <div class="form-content">
              是否延迟发布
              <el-switch size="small" v-model="addMatrixCodeForm.isOpenDelay"></el-switch>
            </div>
          </div>
          <div class="form-item" v-show="addMatrixCodeForm.isOpenDelay">
            <div class="form-content">
              延迟时长

              <el-input-number
                size="small"
                v-model="addMatrixCodeForm.delayPublishSecond"
                :min="1"
                :max="86400"
              />秒
            </div>
          </div>
          <el-button type="primary" @click="addMatrixCodeConfrim">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Marketing_activityList,
  getActivityListTotalNum,
  deleteActivity,
  findUserFuncInfo,
  batchPublishMatrixCode,
  getMatrixCodeGroupList,
  getGroupMemberInfo,
} from "../api/index";
export default {
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      pageCount: 0,
      activeList: [],
      isHavMatrixCode: false,
      matrixCodeList: [],
      groupMemberList: [],
      isShowAddMartixCodeGroupPopup: false,
      addMatrixCodeForm: {
        groupId: "",
        memberIds: [],
        activityId: "",
        isOpenDelay: false,
        delayPublishSecond: "",
      },
    };
  },
  watch: {
    isShowAddMartixCodeGroupPopup(val) {
      if (!val) {
        this.addMatrixCodeForm = {
          groupId: "",
          memberIds: [],
          activityId: "",
          isOpenDelay: false,
          delayPublishSecond: "",
        };
      }
    },
  },
  mounted() {
    findUserFuncInfo({
      userFuncType: 18,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30) {
          this.isHavMatrixCode = true;
          this.getMatrixCodeGroupList();
        }
      }
    });
    this.getPageData();
  },
  methods: {
    addMatrixCodeConfrim() {
      let params = JSON.parse(JSON.stringify(this.addMatrixCodeForm));
      if (params.isOpenDelay && !params.delayPublishSecond) {
        return this.$notify({
          title: "提示",
          message: "请填写延迟时间",
          type: "error",
          duration: 3000,
        });
      }
      if (!params.groupId) {
        return this.$notify({
          title: "提示",
          message: "请选择分组",
          type: "error",
          duration: 3000,
        });
      }
      if (params.memberIds.length) {
        delete params.groupId;
        params.memberIds = JSON.stringify(params.memberIds);
      }
      batchPublishMatrixCode(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "发布成功",
            type: "success",
            duration: 1000,
          });
          this.isShowAddMartixCodeGroupPopup = false;
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 3000,
          });
        }
      });
    },
    groupIdChange() {
      this.addMatrixCodeForm.memberIds = [];
      this.getGroupMemberInfo();
    },
    getGroupMemberInfo() {
      this.groupMemberList = [];
      getGroupMemberInfo({
        groupId: this.addMatrixCodeForm.groupId,
        pageNumber: 1,
        pageSize: 9999,
      }).then((res) => {
        if (res.code == 1) {
          this.groupMemberList = res.data.list;
        }
      });
    },
    batchPublishMatrixCode(item) {
      this.addMatrixCodeForm.activityId = item.activityId;
      this.isShowAddMartixCodeGroupPopup = true;
    },
    getMatrixCodeGroupList() {
      getMatrixCodeGroupList({
        pageNumber: 1,
        pageSize: 9999,
      }).then((res) => {
        if (res.code == 1) {
          this.matrixCodeList = res.data.list;
        } else {
          this.matrixCodeList = [];
        }
      });
    },
    getMarketing_activityList() {
      Marketing_activityList({
        activityType: 101,
        pageNo: this.pageNo,
        row: this.pageSize,
        timeStatus: this.timeStatus,
        customParam: "resourcesNum,usedNum",
      }).then((res) => {
        if (res.code == 1) {
          this.activeList = res.data;
        } else if (res.code == -1) {
          this.activeList = [];
        } else {
        }
      });
    },
    getActivityListTotalNum() {
      getActivityListTotalNum({
        activityType: 101,
        pageNo: this.pageNo,
        row: this.pageSize,
        timeStatus: this.timeStatus,
        customParam: "resourcesNum,usedNum",
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data.totalNum;
        } else {
          this.pageCount = 0;
        }
      });
    },
    getPageData() {
      this.getMarketing_activityList();
      this.getActivityListTotalNum();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getMarketing_activityList();
    },
    addMarketingActivity() {
      this.$router.push("/marketing/addAndEdit");
    },
    lookDetail(row) {
      this.$router.push(`/marketing/bdmItem?activityId=${row.activityId}`);
    },
    updateActive(row) {
      console.log(row, "updateActive");
      // localStorage.setItem("updateActivityId", row.activityId);
      if (this.$route.path == "/matrixCodeResource") {
        this.$router.push(`/matrixCodeResource/addAndEdit?activityId=${row.activityId}`);
      } else {
        this.$router.push(`/marketing/addAndEdit?activityId=${row.activityId}`);
      }
    },
    delActive(row) {
      console.log(row, "delActive");
      this.$confirm("此操作将永久删除该活动, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        deleteActivity({
          activityId: row.activityId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getMarketing_activityList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
  .popup {
    .popup-container {
      padding: 20px;
    }
    &.add-matrix-code {
      z-index: 999;
      .popup-content {
        width: 400px;
        .popup-container {
          text-align: center;
          .el-button {
            margin-top: 20px;
          }
          .form-item {
            width: 100%;
            display: flex;
            align-items: center;
            text-align: left;
            min-height: 40px;
            .text-red {
              line-height: 1.5;
              color: red;
            }
            .form-title {
              width: 80px;
              text-align: right;
              margin-right: 10px;
              line-height: 40px;
              font-size: 14px;
            }
            .form-content {
              flex: 1;
              .el-input-number {
                width: 130px;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
